<script lang="ts">
	const YEAR = new Date().getFullYear();
</script>

<footer id="footer">
	<ul class="icons">
		<li>
			<a href="https://twitter.com/kcancleaning" class="icon brands fa-twitter">
				<span class="label">Twitter</span>
			</a>
		</li>
		<li>
			<a
				href="https://www.facebook.com/profile.php?id=61551808446448"
				class="icon brands fa-facebook-f"
			>
				<span class="label">Facebook</span>
			</a>
		</li>
		<li>
			<a href="https://www.instagram.com/kcancleaning" class="icon brands fa-instagram">
				<span class="label">Instagram</span>
			</a>
		</li>
		<li>
			<a href="https://www.tiktok.com/@king.can.cleaning?lang=en" class="icon brands fa-tiktok">
				<span class="label">TikTok</span>
			</a>
		</li>
		<li>
			<a href="mailto:contact@kcancleaning.com" class="icon solid fa-envelope"
				><span class="label">Email</span></a
			>
		</li>
	</ul>
	<ul class="copyright">
		<li>&copy; {YEAR} <i class="icon solid fa-crown" /> King Can Cleaning</li>
	</ul>
	<ul class="created-by copyright">
		<li>
			Created and hosted by <a href="https://theoretically.co">Theoretically Inc.</a>
		</li>
	</ul>
</footer>

<style lang="scss">
	ul {
		&:nth-child(2) {
			margin: 0 0 1em 0;
		}
	}
	#footer {
		.copyright.created-by {
			font-size: 0.65em;
		}
	}
</style>
